import {
  ComponentOperationType,
  ComponentType,
  GroopitFilterAssignmentDisplayDTO,
  GroopitFilterComponentDisplayDTO,
  GroopitFilterDisplayDTO,
} from "groopit-js/client";
import {
  GroopitFilter,
  UnnamedGroopitFilterDisplayDTO,
  updateGroopitFilter,
} from "../GroopitFilterDTO";
import {
  FilterActions,
  FilterAddAssignmentActionType,
  FilterAddCreatorActionType,
  FilterAddDateRangeActionType,
  FilterAddKeywordQueryActionType,
  FilterReplaceKeywordQueryActionType,
  FilterExcludeComponentFromAIActionType,
  FilterIncludeComponentInAIActionType,
  FilterRemoveAssignmentActionType,
  FilterRemoveChoiceActionType,
  FilterRemoveComponentActionType,
  FilterRemoveCreatorActionType,
  FilterRemoveDataTypeActionType,
  FilterRemoveDateRangeActionType,
  FilterRemoveKeywordQueryActionType,
  FilterRemoveTagActionType,
  FilterReplaceCreatorsActionType,
  FilterReplaceFilterActionType,
  FilterResetFilterActionType,
  FilterUpdateComponentActionType,
} from "./FilterActions";

export function FilterReducer(
  state: GroopitFilter,
  action: FilterActions,
): GroopitFilter {
  const newFilter = GroopitFilterDisplayDTO.fromJS(state.filter.toJSON());

  switch (action.type) {
    case FilterAddCreatorActionType: {
      if (!action.assignment) {
        newFilter.creators = [...newFilter.creators, action.creator];
      } else {
        const assignmentFilter = newFilter.assignments.find(
          (a) => a.id === action.assignment?.id,
        );
        if (assignmentFilter) {
          assignmentFilter.creators = assignmentFilter.creators
            ? [...assignmentFilter.creators, action.creator]
            : [action.creator];
        } else {
          newFilter.assignments = [
            ...newFilter.assignments,
            new GroopitFilterAssignmentDisplayDTO({
              id: action.assignment.id,
              title: action.assignment.title ?? "",
              assignmentPhotoUrl: action.assignment.assignmentPhotoUrl,
              creators: [action.creator],
            }),
          ];
        }
      }
      return updateGroopitFilter(state, newFilter, false);
    }
    case FilterRemoveCreatorActionType: {
      if (!action.assignmentId) {
        newFilter.creators = newFilter.creators.filter(
          (c) => c.id !== action.creatorId,
        );
      } else {
        const assignmentFilter = newFilter.assignments.find(
          (a) => a.id === action.assignmentId,
        );
        if (assignmentFilter) {
          assignmentFilter.creators = assignmentFilter.creators?.filter(
            (c) => c.id !== action.creatorId,
          );
        }
      }
      return updateGroopitFilter(state, newFilter, false);
    }
    case FilterReplaceCreatorsActionType: {
      if (!action.assignment) {
        newFilter.creators = action.creators;
      } else {
        const assignmentFilter = newFilter.assignments.find(
          (a) => a.id === action.assignment?.id,
        );
        if (assignmentFilter) {
          assignmentFilter.creators = action.creators;
        } else {
          newFilter.assignments = [
            ...newFilter.assignments,
            new GroopitFilterAssignmentDisplayDTO({
              id: action.assignment.id,
              title: action.assignment.title ?? "",
              assignmentPhotoUrl: action.assignment.assignmentPhotoUrl,
              creators: action.creators,
            }),
          ];
        }
      }
      return updateGroopitFilter(state, newFilter, false);
    }
    case FilterAddDateRangeActionType: {
      if (!action.assignment) {
        newFilter.dateRange = action.dateRange;
      } else {
        const assignmentFilter = newFilter.assignments.find(
          (a) => a.id === action.assignment?.id,
        );
        if (assignmentFilter) {
          assignmentFilter.dateRange = action.dateRange;
        } else {
          newFilter.assignments = [
            ...newFilter.assignments,
            new GroopitFilterAssignmentDisplayDTO({
              id: action.assignment.id,
              title: action.assignment.title ?? "",
              assignmentPhotoUrl: action.assignment.assignmentPhotoUrl,
              dateRange: action.dateRange,
            }),
          ];
        }
      }
      return updateGroopitFilter(state, newFilter, false);
    }
    case FilterRemoveDateRangeActionType: {
      if (action.assignmentId == undefined) {
        newFilter.dateRange = undefined;
      } else {
        const assignmentFilter = newFilter.assignments.find(
          (a) => a.id === action.assignmentId,
        );
        if (assignmentFilter) {
          assignmentFilter.dateRange = undefined;
        }
      }
      return updateGroopitFilter(state, newFilter, false);
    }
    case FilterAddKeywordQueryActionType: {
      newFilter.query = [...newFilter.query, action.query];
      return updateGroopitFilter(state, newFilter, false);
    }
    case FilterRemoveKeywordQueryActionType: {
      newFilter.query = newFilter.query.filter((q) => q !== action.query);
      return updateGroopitFilter(state, newFilter, false);
    }
    case FilterReplaceKeywordQueryActionType: {
      newFilter.query = [...action.keywords];
      return updateGroopitFilter(state, newFilter, false);
    }
    case FilterRemoveTagActionType: {
      newFilter.tags = newFilter.tags.filter((t) => t !== action.tag);
      return updateGroopitFilter(state, newFilter, false);
    }
    case FilterRemoveChoiceActionType: {
      newFilter.choices = newFilter.choices.filter((c) => c !== action.choice);
      return updateGroopitFilter(state, newFilter, false);
    }
    case FilterRemoveDataTypeActionType: {
      newFilter.feedFilterDataTypes = newFilter.feedFilterDataTypes.filter(
        (d) => d !== action.dataType,
      );
      return updateGroopitFilter(state, newFilter, false);
    }
    case FilterAddAssignmentActionType: {
      newFilter.assignments = [
        ...newFilter.assignments,
        new GroopitFilterAssignmentDisplayDTO({
          id: action.assignment.id,
          title: action.assignment.title ?? "",
          assignmentPhotoUrl: action.assignment.assignmentPhotoUrl,
        }),
      ];
      return updateGroopitFilter(state, newFilter, false);
    }
    case FilterRemoveAssignmentActionType: {
      newFilter.assignments = newFilter.assignments.filter(
        (a) => a.id !== action.assignmentId,
      );
      return updateGroopitFilter(state, newFilter, false);
    }
    case FilterUpdateComponentActionType: {
      const componentModel = action.assignment.components.find(
        (c) => c.componentModel_Id === action.componentId,
      );
      let assignmentFilter = newFilter.assignments.find(
        (a) => a.id === action.assignment.id,
      );
      if (!assignmentFilter) {
        assignmentFilter = new GroopitFilterAssignmentDisplayDTO({
          id: action.assignment.id,
          title: action.assignment.title ?? "",
          assignmentPhotoUrl: action.assignment.assignmentPhotoUrl,
        });
        newFilter.assignments = [...newFilter.assignments, assignmentFilter];
      }
      const componentFilter = assignmentFilter.components?.find(
        (c) => c.componentModelId === action.componentId,
      );
      if (componentFilter) {
        assignmentFilter.components = assignmentFilter.components?.map((c) =>
          c.componentModelId === action.componentId
            ? new GroopitFilterComponentDisplayDTO({
                componentModelId: action.componentId,
                componentModelType:
                  componentModel?.type ?? c.componentModelType,
                componentModelDescription:
                  componentModel?.description ?? c.componentModelDescription,
                operation: action.operation,
                value:
                  action.operation === ComponentOperationType.Any ||
                  action.operation === ComponentOperationType.None
                    ? undefined
                    : action.value,
              })
            : c,
        );
      } else {
        assignmentFilter.components = [
          ...(assignmentFilter.components ?? []),
          new GroopitFilterComponentDisplayDTO({
            componentModelId: action.componentId,
            componentModelType: componentModel?.type ?? ComponentType.Unknown,
            componentModelDescription: componentModel?.description ?? "",
            operation: action.operation,
            value: action.value,
          }),
        ];
      }
      return updateGroopitFilter(state, newFilter, false);
    }
    case FilterRemoveComponentActionType: {
      const assignmentFilter = newFilter.assignments.find(
        (a) => a.id === action.assignmentId,
      );
      if (assignmentFilter) {
        assignmentFilter.components = assignmentFilter.components?.filter(
          (c) => c.componentModelId !== action.componentId,
        );
      }
      return updateGroopitFilter(state, newFilter, false);
    }
    case FilterIncludeComponentInAIActionType: {
      const assignmentFilter = newFilter.assignments.find(
        (a) => a.id === action.assignmentId,
      );
      if (assignmentFilter) {
        assignmentFilter.componentModelIds = [
          ...(assignmentFilter.componentModelIds ?? []),
          action.componentId,
        ];
      }
      return updateGroopitFilter(state, newFilter, false);
    }
    case FilterExcludeComponentFromAIActionType: {
      const assignmentFilter = newFilter.assignments.find(
        (a) => a.id === action.assignment.id,
      );
      if (assignmentFilter) {
        if (assignmentFilter.componentModelIds) {
          assignmentFilter.componentModelIds =
            assignmentFilter.componentModelIds?.filter(
              (id) => id !== action.componentId,
            );
        } else {
          assignmentFilter.componentModelIds = action.assignment.components
            .filter((c) => c.componentModel_Id !== action.componentId)
            .map((c) => c.componentModel_Id);
        }
      } else {
        newFilter.assignments = [
          ...newFilter.assignments,
          new GroopitFilterAssignmentDisplayDTO({
            id: action.assignment.id,
            title: action.assignment.title ?? "",
            assignmentPhotoUrl: action.assignment.assignmentPhotoUrl,
            componentModelIds: action.assignment.components
              .filter((c) => c.componentModel_Id !== action.componentId)
              .map((c) => c.componentModel_Id),
          }),
        ];
      }
      return updateGroopitFilter(state, newFilter, false);
    }
    case FilterReplaceFilterActionType:
      return action.filter;
    case FilterResetFilterActionType:
      return new UnnamedGroopitFilterDisplayDTO();
  }
}
